
import base64 from "base-64";
import * as Constants from '../common/constants';

const CC_BASIC_AUTH = `Basic ${base64.encode(`${Constants.CC_API_USERNAME}:${Constants.CC_API_PASSWORD}`)}`;
const LISTING_BASIC_AUTH = `Basic ${base64.encode(`${Constants.LISTING_API_USERNAME}:${Constants.LISTING_API_PASSWORD}`)}`;
export const apis = {
    saveJsons: (data) => postJson(`/api/save-json`, data),
    updateRule: async (data, ruleId) => postJson(`${Constants.LISTING_RULE_URL}/update/${ruleId}`,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false,
        true),
    addRule: async (data) => postJson( Constants.LISTING_RULE_URL,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false,
        true),
    getRules: async () => getJson( Constants.LISTING_RULE_URL,
        {"authorization": LISTING_BASIC_AUTH}),
    deleteRule: async (data, ruleId) => deleteJson(`${Constants.LISTING_RULE_URL}/${ruleId}`,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false),
    updateRuleManager: async (data, ruleId) => postJson(`${Constants.LISTING_RULE_MANAGER_URL}/update/${ruleId}`,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false,
        true),
    addRuleManager: async (data) => postJson(Constants.LISTING_RULE_MANAGER_URL,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false,
        true),
    getRulesManager: async () => getJson(Constants.LISTING_RULE_MANAGER_URL,
        {"authorization": LISTING_BASIC_AUTH}),
    deleteRuleManager: async (data, ruleId) => deleteJson(`${Constants.LISTING_RULE_MANAGER_URL}/${ruleId}`,
        {...data},
        {"authorization": LISTING_BASIC_AUTH},
        null,
        false),
    updateDefaultBinding: async (data, bindingId) => postJson(`${Constants.DEFAULT_BINDINGS_URL}/update-bindings/${bindingId}`,
        {...data},
        {},
        null),
    addDefaultBinding: async (data) => postJson(`${Constants.DEFAULT_BINDINGS_URL}/update-bindings`,
        {...data},
        {},
        null),
    updateDefaultBindingLegend: async (data, bindingId) => postJson(`${Constants.DEFAULT_BINDINGS_URL}/update-bindings-legend/${bindingId}`,
        {...data},
        {},
        null),
    addDefaultBindingLegend: async (data) => postJson(`${Constants.DEFAULT_BINDINGS_URL}/update-bindings-legend`,
        {...data},
        {},
        null),
    getDefaultBindings: async (idCompany = '') => getJson(`${Constants.DEFAULT_BINDINGS_URL}/get-bindings` + (idCompany ? `/${idCompany}` : '')),
    deleteDefaultBinding: async (bindingId) => getJson(`${Constants.DEFAULT_BINDINGS_URL}/delete-bindings/${bindingId}`),
    deleteDefaultBindingLegend: async (bindingId) => getJson(`${Constants.DEFAULT_BINDINGS_URL}/delete-bindings-legend/${bindingId}`),
    getMockData: async () => getJson(`${Constants.MOCK_DATA_URL}/get-mock-data`),
    updateMockData: async (data, dataId) => postJson(`${Constants.MOCK_DATA_URL}/update-mock-data/${dataId}`,
        {...data},
        {},
        null),
    addMockData: async (data) => postJson(`${Constants.MOCK_DATA_URL}/update-mock-data`,
        {...data},
        {},
        null),
    deleteMockData: async (dataId) => getJson(`${Constants.MOCK_DATA_URL}/delete-mock-data/${dataId}`),
    getCompanies: async () => getJson(`${Constants.TEMPLATE_ADMIN_URL}/getCompanies`),
    getColorSet: async (idTemplate) => getJson(`${Constants.COLOR_SET_URL}/getColorSet/${idTemplate}`),
    getTemplate: async (idTemplate) => getJson(`${Constants.TEMPLATE_ADMIN_URL}/getTemplate/${idTemplate}`),
    getTemplateIdsRelatedBySet: async (idTemplate) => getJson(`${Constants.TEMPLATE_ADMIN_URL}/getTemplateIdsRelatedBySet/${idTemplate}`),
    getTemplateSets: async (idCompany) => getJson(`${Constants.TEMPLATE_ADMIN_URL}/getTemplateSets/${idCompany}`),
    getVariableDataMergeFields: async () => getJson(`${Constants.TEMPLATE_ADMIN_URL}/variableDataMergeFields`),
    getVariableDataMergeField: async (idVariableDataMergeField) => getJson(`${Constants.TEMPLATE_ADMIN_URL}/variableDataMergeFields/${idVariableDataMergeField}`),
    addVariableDataMergeField: async (data) => postJson(`${Constants.TEMPLATE_ADMIN_URL}/variableDataMergeFields/create`,
        {...data},
        {},
        null),
    updateVariableDataMergeField: async (data, idVariableDataMergeField) => postJson(`${Constants.TEMPLATE_ADMIN_URL}/variableDataMergeFields/update/${idVariableDataMergeField}`,
        {...data},
        {},
        null),
    deleteVariableDataMergeField: async (idVariableDataMergeField) => postJson(`${Constants.TEMPLATE_ADMIN_URL}/variableDataMergeFields/delete/${idVariableDataMergeField}`,
        null,
        {},
        null),
    getSystemConstants: async () => getJson(`${Constants.SYSTEM_CONSTANTS_URL}/system-constants`),
    generateSvgThumbnail: async (idTemplate) => getJson(`${Constants.TEMPLATE_ADMIN_URL}/generateSvgThumbnail/template/${idTemplate}`),
};

export const createCCApis = (host="") => {
    return {
        ccConfigJson: async (data) => postJson(`${host}${Constants.CC_CONFIG_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            true,),
        updateCcConfigJson: async (data, ccConfigId) => patchJson(`${host}${Constants.CC_CONFIG_URL}/${ccConfigId}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            true,),
        auditLogJson: async (data) => postJson(`${host}${Constants.CC_AUDIT_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            true,
            true),
        addTemplateJson: async (data, templateId) => postJson(`${host}${Constants.CC_TEMPLATE_JSON_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH, "template_id": templateId},
            null,
            true,),
        saveXdToCcConfigJson: async (data) => postJson(`${host}${Constants.CC_XD_TEMPLATE_TO_CC_CONFIG_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        updateXdToCcConfigJson: async (data, _id) => patchJson(`${host}${Constants.CC_XD_TEMPLATE_TO_CC_CONFIG_URL}/${_id}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,),
        getTemplateInfo: async (data) => postJson(`${host}${Constants.CC_TEMPLATE_INFO}` ,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        getTemplateInfoByCcConfig: async (data) => postJson(`${host}${Constants.CC_TEMPLATE_INFO_BY_CCCONFIG}` ,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        createTemplatePath: async (data) => postJson(`${host}${Constants.CC_TEMPLATE_PATH_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        updateTemplatePath: async (data) => postJson(`${host}${Constants.CC_UPDATE_TEMPLATE_PATH_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        getTemplateByPath: async (data) => postJson(`${host}${Constants.CC_GET_TEMPLATE_BY_PATH_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        downloadZipFile: async (data) => postJson(`${host}${Constants.CC_TEMPLATE_DOWNLOAD_ZIP_FILE_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,
            false,
            true),
        getPluginList: async () => getJson(`${host}${Constants.CC_GET_PLUGIN_LIST}`, {"authorization": CC_BASIC_AUTH,}),
        downloadPlugin: async (data) => postJson(`${host}${Constants.CC_DOWNLOAD_PLUGIN}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,
            false,
            true),
        updateStyles: async (data, styleId) => patchJson(`${host}${Constants.CC_STYLE_URL}/${styleId}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,),
        addStyles: async (data) => postJson(`${host}${Constants.CC_STYLE_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            false,
            true),
        getStyles: async () => getJson(`${host}${Constants.CC_STYLE_URL}`, {"authorization": CC_BASIC_AUTH}),
        getFonts: async () => getJson(`${host}${Constants.CC_FONTS_URL}`, {"authorization": CC_BASIC_AUTH}),
        updateColors: async (data, colorId) => patchJson(`${host}${Constants.CC_COLOR_URL}/${colorId}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,),
        addColors: async (data) => postJson(`${host}${Constants.CC_COLOR_URL}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            false,
            true),
        getColors: async () => getJson(`${host}${Constants.CC_COLOR_URL}`, {"authorization": CC_BASIC_AUTH}),
        deleteColors: async (data, colorId) => deleteJson(`${host}${Constants.CC_COLOR_URL}/${colorId}`,
            {data},
            {"authorization": CC_BASIC_AUTH},
            null,
            false),
        getHardCloneSurface: async (data) => postJson(`${host}${Constants.CC_HARD_CLONE_SURFACE}`,
            {data},
            {"authorization": CC_BASIC_AUTH,},
            null,),
        getRelatedTemplates: async (templateId) => getJson(`${host}${Constants.CC_GET_RELATED_TEMPLATES}/${templateId}`),
        refreshTemplateThumbnails: async (templateId, numSurfaces = null) => fetch(
            `${host}${Constants.CC_REFRESH_TEMPLATE_THUMBNAILS}/${templateId}${numSurfaces ? ("/"+numSurfaces) : ""}`,
            {method: "PATCH"}
        ),
        uploadPlugin: async (plugin) => getJson(`${host}${Constants.CC_UPLOAD_PLUGIN}/${plugin}`),
        getCurrentHost: () => host,
        getVersions: () => getJson(`${host}${Constants.CC_VERSIONS}`),
        getHost: async (idTemplate = "", idState = "") => getJson(`${host}${Constants.CC_HOST_URL}?templateId=${idTemplate}&stateId=${idState}`),
        getToken: async () => getJson("/xdapi/api/get-internal-cc-token"),
    }
}


const deleteJson = async (url, data, headers = null, cookie = null, unescape = false) => {
    try {
        let newHeaders = {
            "content-type": "application/json",
            "accept-encoding": "gzip",
            "cookie": cookie,
            ...headers
        };

        const jsonData = data && JSON.stringify(data);
        //This is for the config-component, when posting a cc-config json that might have a new line \n in the binding data.
        let body = unescape ? jsonData.replace(/\\\\/g, "\\") : jsonData;

        const result = await fetch(
            url,
            {
                method: "DELETE",
                body: body,
                headers: {
                    ...newHeaders
                },
            }
        );
        return await result.json();
    }
    catch (e) {
        console.log("Error running deleteJson", e);
        return null;
    }
};

const getJson = async (url, headers = null) => {
    try {
        const res = await fetch(url, {
            credentials: "include",
            method: "GET",
            headers: {
                "Accept": "application/json",
                "content-type": "application/json",
                ...headers
            },
        });
        return await res.json();
    }
    catch (e) {
        console.log("Error running getJson", e);
        return null;
    }
};

const postJson = async (url, data, headers = null, cookie = null, unescape = false, rawData = false) => {
    try {
        let newHeaders = {
            "content-type": "application/json",
            "accept-encoding": "gzip",
            "cookie": cookie,
            ...headers
        };

        const jsonData = data && JSON.stringify(data);
        //This is for the config-component, when posting a cc-config json that might have a new line \n in the binding data.
        let body = unescape ? jsonData.replace(/\\\\/g, "\\") : jsonData;

        const result = await fetch(
            url,
            {
                method: "POST",
                body: body,
                headers: {
                    ...newHeaders
                },
            }
        );
        return rawData ? await result : await result.json();
    }
    catch (e) {
        console.log("Error running postJson", e);
        return null;
    }
};
const patchJson = async (url, data, headers = null, cookie = null, unescape = false) => {
    try {
        let newHeaders = {
            "content-type": "application/json",
            "accept-encoding": "gzip",
            "cookie": cookie,
            ...headers
        };

        const jsonData = data && JSON.stringify(data);
        //This is for the config-component, when posting a cc-config json that might have a new line \n in the binding data.
        let body = unescape ?  jsonData.replace(/\\\\/g, "\\") : jsonData;

        const result = await fetch(
            url,
            {
                method: "PATCH",
                body: body,
                headers: {
                    ...newHeaders
                },
            }
        )
        return await result.json();
    }
    catch (e) {
        console.log("Error running patchJson", e);
        return null;
    }
};
